// extracted by mini-css-extract-plugin
module.exports = {"container":"main_container_2CqRR"};